import { render, staticRenderFns } from "./ListAlertaCargaView.vue?vue&type=template&id=6401872c&"
import script from "./ListAlertaCargaView.vue?vue&type=script&lang=ts&"
export * from "./ListAlertaCargaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports